import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';

import { PricingRoutes } from 'pricing/types';
import { testId } from 'pricing/utilities/test/dataTestId';

function CancelContract(): ReactElement {
  const history = useHistory();

  const handleNavigateTo = () => history.push(PricingRoutes.ContractList);

  return (
    <Button data-testid={testId.contractCancelButton} onClick={handleNavigateTo}>
      Cancel
    </Button>
  );
}

export default CancelContract;
